<template>
    <div class="layout-container">
        <!-- 头部 -->
        <!-- 下面代码意义：当路径等于/home，header才显示 -->
        
        <!-- Home 和 Records 头部 -->
        <HomeRecordsHeader />

        <!-- Register 头部 -->
        <RegisterHeader v-if="$route.path==='/register'"/>

        <!-- Message 头部 -->
        <MessageProfileHeader path="message" text="メッセージセンター"/>

        <!-- Profile 头部 -->
        <MessageProfileHeader path="profile" text="個人情報"/>

        <!-- 收货地址页面(Addresses) 头部 -->
        <AddressesHeader />

        <!-- 商品详情页面(ProductDetails) 头部 -->
        <ProductDetailsHeader path="productDetails" headerTitle="商品詳細"/>

        <!-- 商品下单页面(DecideToOrder) 头部 -->
        <ProductDetailsHeader path="decideToOrder" headerTitle="注文確認"/>

        <!-- Like 头部 -->
        <MessageProfileHeader path="like" text="お気に入り"/>

        <!-- Cart 头部 -->
        <MessageProfileHeader path="cart" text="買い物かご"/>

        <!-- 宣传页详情 头部 -->
        <ProductDetailsHeader path="bannerDetail" headerTitle="イベント詳細"/>
        
        <!-- 特定商品列表 头部 -->
        <ProductDetailsHeader path="remainedTargetProducts" headerTitle="商品リスト"/>

        <!-- 身体 -->
        <main :class="mainClass" v-loading="$store.state.global.vLoading">
            <!-- 你想让路由组件在哪里展示，就在哪里写下面这行
            注意：下面这行一定别忘了，因为你不写它，别的地方写了半天，路由不知道该在哪里展示 -->
            <Transition :name="transitionName">
                <router-view></router-view>
            </Transition>
        </main>

        <!-- 脚部 -->
        <!-- 读文档发现，fixed这个prop，控制tabbar是否是固定定位，脱离文档流
             这里要设置成false，否则滚动条捅进tabbar里，而且tabbar还遮挡部分main
            的内容  -->
        <!-- <TabBar v-if="$route.path !== '/productDetails'"/>  -->
        <TabBar v-if="!['/productDetails','/search', '/remainedTargetProducts'].includes($route.path)"/>
    </div>
        
</template>

<script>
import HomeRecordsHeader from "@/components/Layout/components/HomeRecordsHeader"
import MessageProfileHeader from "@/components/Layout/components/MessageProfileHeader"
import RegisterHeader from "@/components/Layout/components/RegisterHeader"
import AddressesHeader from "@/components/Layout/components/AddressesHeader"
import ProductDetailsHeader from "@/components/Layout/components/ProductDetailsHeader"
import TabBar from "@/components/Layout/components/TabBar"
export default {
    name: "Layout",
    
    components: {
        HomeRecordsHeader,
        MessageProfileHeader,
        RegisterHeader,
        AddressesHeader,
        ProductDetailsHeader,
        TabBar
    },

    data() {
        return {
            // searchValue: "",
            //Tabbar当前选中的tab的索引值，一开始是0，也就是第一个
            // active: 0,
            transitionName: ""
        }
    },

    computed: {
        // 身体部分动态类名 为了让有的身体背景是灰的，有的是白的

        mainClass() {
            const path = this.$route.path;
            return path === "/register" ? 'white-main' : 'gray-main' 
        }
    },

    watch: {
        $route(to, from) {
            if (from.name === "home" && to.name === "search") {
                this.transitionName = "slide";
            } else {
                this.transitionName = "";
            }
        }
    }

}
</script>

<style scoped>
/* 容器用flex布局，最主要的意义，是为了让main可以占据除头部，脚部外剩余的空间*/
.layout-container {
    display: flex;
    /*让布局竖过来*/
    flex-direction: column;
    /*容器必须是纵向100%*/
    height: 100vh;
    
}

/* 为了让子组件RegisterHeader也生效，这里让它穿透过去
  这里不是因为应用了第三方组件库，这里是让父组件的样式作用到子组件 */
:deep(.layout-header) {
    height: 54px;
    box-shadow: 0 2px 4px rgb(0, 0, 0, 0.1);
    /* 阴影被别的盒子压住了，所以给它相对定位，既不让它脱离文档流*/
    position: relative;
    /* 不能设置太高 */
    z-index: 999;
}

/* 消息组件头部 */
.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.message-header .logo {
    position: absolute;
    left: 0;
    color: var(--red-light);
    font-size: 20px;
}
.msg-header {
    height: 46px;
}
.msg-header #msg-header-img {
    border-radius: 20px;
    width: 30px;
    height: 30px;
}

.msg-header .van-hairline--bottom::after {
    border-bottom: none;
}

main {
    
    /*让main占据剩余的空间*/
    flex: 1;
    /*使其纵向出现滚动条*/
    overflow-y: auto;
}

/* 动态类名 路径不是/register时 */
.gray-main {
    background-color: #F9FAFB;
}

/* 动态类名 路径为/register时 */
.white-main {
    background-color: #fff;
}

/* loading状态遮罩 */
:deep(.el-loading-mask) {
    z-index: 0;
    background-color: #fff;
}

/* .search-fade-enter {
    opacity: 0;
}

.search-fade-enter-active {
    transition: opacity 2s ease;
}

.search-fade-enter-to {
    opacity: 1;
} */

/* 动画持续 0.35 秒，采用 bezier 贝塞尔曲线，让它有一种踩刹车一样的减速高级感 */
.slide-enter-active,
.slide-leave-active {
  transition: transform 1.35s cubic-bezier(0.16, 1, 0.3, 1);
}

/* 刚进场时，新页面呆在屏幕右侧外面 (100% 处) */
.slide-enter {
  transform: translateX(100%);
}

/* 进场完毕后，回归原位 (0 处)；同时旧页面离场时往左侧稍微退出一点 (-30%) */
.slide-leave-to {
  transform: translateX(-30%);
}

</style>